
/**
 * Media Selectors
 */
const selectors = {
    isMobile: window.window.matchMedia("(max-width: 991px)").matches,
    isDesktop: window.window.matchMedia("(min-width: 992px)").matches,
}

/**
 * Accordion Onclick function
 */
function productDetailsList() {

    // When is Desktop View
    if (selectors.isDesktop) {
        $('[data-js="read-more-desktop"]').on('click', function (e) {
            e.preventDefault();
            $(this).hide();
            $(".read-more-desktop ~ li:not(.read-more-mobile)").show();
        });
    }

    // When is Mobile View
    if (selectors.isMobile) {
        $('[data-js="read-more-mobile"]').on('click', function (e) {
            e.preventDefault();
            $(this).hide();
            $(".read-more-mobile ~ li:not(.read-more-desktop)").show();
        });
    }
}

/**
 * Initialize the function
 */
function init() {
    productDetailsList();
}

export default {
    init
};
